/**
 * Returns an HTML element. This element is either:
 * 1. identical to `elementOrSelector` if `elementOrSelector` is an HTMLElement, OR
 * 2. the result of `document.querySelector` if `elementOrSelector` is a string
 */
function getElement(elementOrSelector) {
    if (typeof elementOrSelector === 'undefined') {
        return;
    }
    if (typeof elementOrSelector !== 'string' && elementOrSelector.nodeType === Node.ELEMENT_NODE) {
        return elementOrSelector;
    }
    if (typeof elementOrSelector === 'string') {
        const element = document.querySelector(elementOrSelector);
        return (element === null || element === void 0 ? void 0 : element.nodeType) === Node.ELEMENT_NODE ? element : undefined;
    }
}

export { getElement };
//# sourceMappingURL=get-element.js.map
